import { render, staticRenderFns } from "./fee-item-detail-v2.vue?vue&type=template&id=933982b8&scoped=true&"
import script from "./fee-item-detail-v2.vue?vue&type=script&lang=js&"
export * from "./fee-item-detail-v2.vue?vue&type=script&lang=js&"
import style0 from "./fee-item-detail-v2.vue?vue&type=style&index=0&id=933982b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933982b8",
  null
  
)

export default component.exports